import React from 'react';
import {ApolloClient} from '@apollo/client';
import {NormalizedCacheObject} from '@apollo/client/cache';

export const DirectConnectApolloClientContext = React.createContext<{
  apolloClient?: ApolloClient<NormalizedCacheObject>;
}>({
  apolloClient: undefined,
});

type DirectConnectApolloClientProviderProps = React.PropsWithChildren<{
  apolloClient: ApolloClient<NormalizedCacheObject>;
}>;

export const DirectConnectApolloClientProvider: React.FC<
  DirectConnectApolloClientProviderProps
> = ({children, apolloClient}) => {
  return (
    <DirectConnectApolloClientContext.Provider value={{apolloClient}}>
      {children}
    </DirectConnectApolloClientContext.Provider>
  );
};
